<div id="time-table" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Academic Calendar</h2>
    <p class="inner-lead mt-3">
      The Academic Calendar of Shah Satnam Ji Girls' College, Sirsa provides a schedule of all important academic
      events, examinations, holidays and activities for the academic year. Students and staff are advised to refer to it
      regularly for planning purposes.
    </p>

    <hr class="divider">

    <!-- Tab Navigation -->
    <div class="report-tabs-wrapper mt-4">
      <div class="report-tabs">
        <button class="tab-btn" [class.active]="activeTab === '2024-25'" (click)="setActiveTab('2024-25')">
          <i class="fa fa-calendar me-2"></i> 2024-25
        </button>
        <button class="tab-btn" [class.active]="activeTab === '2023-24'" (click)="setActiveTab('2023-24')">
          <i class="fa fa-calendar me-2"></i> 2023-24
        </button>
        <button class="tab-btn" [class.active]="activeTab === '2022-23'" (click)="setActiveTab('2022-23')">
          <i class="fa fa-calendar me-2"></i> 2022-23
        </button>
        <button class="tab-btn" [class.active]="activeTab === '2021-22'" (click)="setActiveTab('2021-22')">
          <i class="fa fa-calendar me-2"></i> 2021-22
        </button>
      </div>
    </div>

    <!-- Content Area -->
    <div class="tab-content-area mt-5">

      <!-- 2024-25 Tab -->
      <div *ngIf="activeTab === '2024-25'" class="animate-fade-in">
        <h4 class="section-subtitle">Academic Session 2024-2025</h4>
        <div class="pdf-block">
          <pdf-viewer src="/assets/pdf/academics/Academic Calender 2025-25.pdf" [render-text]="true"
            [original-size]="false" style="width:100%; height:680px; display:block;">
          </pdf-viewer>
        </div>
        <div class="mt-3">
          <a href="/assets/pdf/academics/Academic Calender 2025-25.pdf" target="_blank" class="pdf-download-btn">
            <i class="fa fa-download"></i> Download Academic Calender 2024-25
          </a>
        </div>
      </div>

      <!-- 2023-24 Tab -->
      <div *ngIf="activeTab === '2023-24'" class="animate-fade-in">
        <h4 class="section-subtitle">Academic Calendar 2023-2024</h4>
        <div class="pdf-block">
          <pdf-viewer src="/assets/pdf/academics/Academic-Calendar-for-2023-2024.pdf" [render-text]="true"
            [original-size]="false" style="width:100%; height:680px; display:block;">
          </pdf-viewer>
        </div>
        <div class="mt-3">
          <a href="/assets/pdf/academics/Academic-Calendar-for-2023-2024.pdf" target="_blank" class="pdf-download-btn">
            <i class="fa fa-download"></i> Download Academic Calender 2023-24
          </a>
        </div>
      </div>

      <!-- 2022-23 Tab -->
      <div *ngIf="activeTab === '2022-23'" class="animate-fade-in">
        <h4 class="section-subtitle">Academic Calendar 2022-2023</h4>
        <div class="pdf-block">
          <pdf-viewer src="/assets/pdf/academics/Academic-Calendar-for-2022-23.pdf" [render-text]="true"
            [original-size]="false" style="width:100%; height:680px; display:block;">
          </pdf-viewer>
        </div>
        <div class="mt-3">
          <a href="/assets/pdf/academics/Academic-Calendar-for-2022-23.pdf" target="_blank" class="pdf-download-btn">
            <i class="fa fa-download"></i> Download Academic Calender 2022-23
          </a>
        </div>
      </div>

      <!-- 2021-22 Tab -->
      <div *ngIf="activeTab === '2021-22'" class="animate-fade-in">
        <h4 class="section-subtitle">Academic Calendar 2021-2022</h4>
        <div class="pdf-block">
          <pdf-viewer src="/assets/pdf/academics/Academic-Calendar-for-2021-2022.pdf" [render-text]="true"
            [original-size]="false" style="width:100%; height:680px; display:block;">
          </pdf-viewer>
        </div>
        <div class="mt-3">
          <a href="/assets/pdf/academics/Academic-Calendar-for-2021-2022.pdf" target="_blank" class="pdf-download-btn">
            <i class="fa fa-download"></i> Download Academic Calender 2021-22
          </a>
        </div>
      </div>
    </div>
  </div>
</div>